module.exports = __webpack_public_path__ + "img/button1.37539540.png";